module.exports = __webpack_public_path__ + "img/524.b9216346.jpg";